import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=31e96dde&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=ts"
export * from "./SuccessDialog.vue?vue&type=script&lang=ts"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=31e96dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e96dde",
  null
  
)

export default component.exports